import React from "react"
import { Flex, Box, Text } from "@chakra-ui/react"

type Props = {
  badges: Array<GatsbyTypes.SanitySettingProductBadges>
  pdp?: boolean
}

const ProductBadge: React.FC<Props> = ({ badges, pdp = false }) => {
  const visibleBadges = badges.filter(badge => !badge.hideText)

  if (!visibleBadges.length) return null

  return (
    <Box
      position="absolute"
      top={{ base: pdp ? "20px" : "10px", sm: pdp ? "15px" : "15px", md: pdp ? "25px" : "15px" }}
      left={{ base: pdp ? "16px" : "10px", sm: pdp ? "16px" : "10px", md: pdp ? "24px" : "15px" }}
      pointerEvents="none"
      zIndex={98}
    >
      <Flex position="relative" direction="column" alignItems="flex-start" gap={1.25}>
        {visibleBadges.map((badge, index) => (
          <Flex
            textTransform="uppercase"
            justifyContent="center"
            key={`${badge._key}-${index}`}
            background="primary.corePink"
            borderRadius="5px"
            textAlign="center"
            width="auto"
            height="auto"
          >
            <Flex alignItems="center" color="text.primary" padding={{ base: "2px 6px", md: "4px 8px" }}>
              {badge?.name && (
                <Text variant="productBadge" color="inherit" margin="0" whiteSpace="nowrap">
                  {badge.name}
                </Text>
              )}
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}

export default React.memo(ProductBadge)
